/* ==========================================================================
   TØTE — Upsell and discount strategy, PDP surfaces (T60-T64)
   Kopstorm CommV · assets/kv-offer-r3.js

   Mode mirroring works exactly like round 2: a revealed marker
   [data-kv-test="TXX"] is mirrored onto the html element as kv-t60 ...
   kv-t64, and Intelligems can also set the class directly.

   The blocks are rendered once at the end of the body by
   snippets/kv-offer-r3.liquid and MOVED into the product page here, so no
   product template and no main-product block had to change. Every moved
   node leaves a comment marker behind, so the move is reversible and the
   control state restores exactly.

   Adding posts one /cart/add.js call with the current variant plus the
   chosen line. Every line carries _kv_offer, so the automatic discount or
   the Discount Function can key on it. The current variant id is read from
   the form's hidden input by attribute, never from form.id: a named
   control shadows the element's own id property on a Shopify product form.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__kvOfferR3Init) return;
  window.__kvOfferR3Init = true;

  var IDS = ['T60', 'T61', 'T62', 'T63', 'T64'];
  var root = document.documentElement;
  var host = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  /* ---- money ------------------------------------------------------------ */
  function formatMoney(cents) {
    var fmt = (host && host.dataset.money) || '\u20ac{{amount_with_comma_separator}}';
    var amount = cents / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
      case 'amount_no_decimals_with_comma_separator':
        value = String(Math.round(amount));
        break;
      case 'amount_with_comma_separator':
        value = amount.toFixed(2).replace('.', ',');
        break;
      default:
        value = amount.toFixed(2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---- placement -------------------------------------------------------- */
  function form() {
    return $('.product__info-container product-form.product-form') || $('product-form.product-form');
  }

  function currentVariantId() {
    var f = form();
    if (!f) return null;
    var input = f.querySelector('[name="id"]');
    var val = input && input.value;
    return val ? parseInt(val, 10) : null;
  }

  function place(block) {
    if (block.dataset.kvR3Placed === '1') return;
    var f = form();
    if (!f) return;
    var where = block.dataset.kvR3Place;
    var marker = document.createComment('kv-r3-home-' + block.dataset.kvR3Block);
    block.parentNode.insertBefore(marker, block);
    block.__kvHome = marker;
    if (where === 'before-form') {
      f.parentNode.insertBefore(block, f);
    } else {
      /* Below the payment icons custom_liquid block when the template has
         one, so the offer never sits directly under the buy button. Falls
         back to straight after the form on templates without it (some
         accessory templates). */
      var pay = $('.product__info-container .custom-payment-icons');
      var anchor = pay ? (pay.closest('.custom-liquid') || pay) : f;
      anchor.parentNode.insertBefore(block, anchor.nextSibling);
    }
    block.dataset.kvR3Placed = '1';
    block.hidden = false;
    /* kv-rails.js turns the offer rails into Splide sliders once they are
       actually in the page and visible. */
    document.dispatchEvent(new CustomEvent('kv:r3:placed', { detail: { block: block } }));
  }

  function unplace(block) {
    if (block.dataset.kvR3Placed !== '1') return;
    var marker = block.__kvHome;
    if (marker && marker.parentNode) marker.parentNode.insertBefore(block, marker);
    block.dataset.kvR3Placed = '0';
    block.hidden = true;
  }

  /* ---- cart ------------------------------------------------------------- */
  var busy = false;

  function flash(btn, text) {
    if (!btn) return;
    var prev = btn.dataset.kvPrev || btn.textContent;
    btn.dataset.kvPrev = prev;
    btn.textContent = text;
    setTimeout(function () { btn.textContent = btn.dataset.kvPrev; }, 1800);
  }

  function addToCart(items, btn) {
    if (busy || !items.length) return;
    busy = true;
    if (btn) btn.classList.add('is-loading');

    var drawer = $('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      } catch (e) { /* keep going without drawer sections */ }
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        busy = false;
        if (btn) btn.classList.remove('is-loading');
        if (res.status) { flash(btn, 'Sold out'); return; }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kv-offer-r3' });
        }
        if (drawer && body.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        busy = false;
        if (btn) btn.classList.remove('is-loading');
        flash(btn, 'Try again');
      });
  }

  function line(id, qty, extra) {
    var props = { _kv_offer: 'yes' };
    if (extra) props[extra] = 'yes';
    return { id: id, quantity: qty || 1, properties: props };
  }

  /* ---- colour choice inside a set --------------------------------------- */
  /* Team TØTE asked that the shopper picks the colour of an accessory that
     rides along with a set. A slot maps one to one onto a position in the
     set: slot 1 is the first accessory, slot 2 the second, so the variant id
     at that position is replaced rather than the whole list rebuilt. That
     keeps a slot with only one colour, which renders no picker at all, in
     the set. */
  function optionApply(opt) {
    var slot = opt.closest('[data-kv-r3-slot]');
    if (!slot) return;
    var idx = parseInt(slot.dataset.kvR3SlotIndex, 10);
    if (!idx) return;

    var prev = $('.kv-r3-swatch.is-active', slot);
    var prevWas = prev ? parseInt(prev.dataset.kvR3Was, 10) : 0;
    if (prev === opt) return;
    $$('.kv-r3-swatch', slot).forEach(function (b) {
      b.classList.toggle('is-active', b === opt);
    });

    var host2 = slot.closest('[data-kv-r3-set]') || slot.closest('.kv-r3-choice');
    if (!host2) return;

    var vid = opt.dataset.kvR3Vid;
    var name = opt.dataset.kvR3Name || '';
    var thumb = opt.dataset.kvR3Thumb || '';

    /* thumbnail */
    var img = $('[data-kv-r3-thumb-slot="' + idx + '"] img', host2);
    if (img && thumb) {
      img.src = thumb;
      img.removeAttribute('srcset');
    }

    /* names, both in the set card label and in the note under it */
    $$('[data-kv-r3-name-slot="' + idx + '"]', host2).forEach(function (n) {
      n.textContent = name;
    });

    /* the items line on a ready made set is one string, so only the segment
       that belongs to this slot is rewritten */
    var items = $('[data-kv-r3-items]', host2);
    if (items && host2.dataset.kvR3BaseName) {
      var parts = items.textContent.split(' + ');
      if (parts.length > idx) {
        parts[idx] = name;
        items.textContent = parts.join(' + ');
      }
    }

    /* variant ids */
    if (host2.hasAttribute('data-kv-r3-ids')) {
      var ids = (host2.dataset.kvR3Ids || '').split(',');
      if (ids.length >= idx) {
        ids[idx - 1] = vid;
        host2.dataset.kvR3Ids = ids.join(',');
      }
    }
    var setCard = $('[data-kv-r3-choice="set"]', host2);
    if (setCard) setCard.dataset.kvR3Add = vid;

    /* struck through price, adjusted by the difference between the colours */
    var total = parseInt(host2.dataset.kvR3WasTotal, 10);
    var next = parseInt(opt.dataset.kvR3Was, 10);
    if (!isNaN(total) && !isNaN(next) && !isNaN(prevWas)) {
      total = total - prevWas + next;
      host2.dataset.kvR3WasTotal = String(total);
      /* The swatch buttons also carry data-kv-r3-was, so the strike through
         element has its own attribute. Without that the query returns the
         first swatch on a ready made set, where the picker sits above the
         price. */
      var was = $('[data-kv-r3-strike]', host2);
      if (was) was.textContent = formatMoney(total);
    }
  }

  /* ---- interactions ----------------------------------------------------- */
  function onClick(e) {
    var opt = e.target.closest('[data-kv-r3-opt]');
    if (opt) {
      e.preventDefault();
      e.stopPropagation();
      optionApply(opt);
      return;
    }

    var btn = e.target.closest('[data-kv-r3-add-btn]');
    if (btn) {
      var tile = btn.closest('[data-kv-r3-item]');
      var set = btn.closest('[data-kv-r3-set]');
      var cur = currentVariantId();
      if (!cur) return;
      e.preventDefault();

      if (tile) {
        var vid = parseInt(tile.dataset.variant, 10);
        var kind = tile.dataset.kind === 'addon' ? '_kv_offer_addon' : '_kv_offer_second';
        addToCart([line(cur, 1), line(vid, 1, kind)], btn);
        return;
      }
      if (set) {
        if (set.dataset.kvR3Duo === '1') {
          addToCart([line(cur, 2, '_kv_offer_second')], btn);
          return;
        }
        var ids = (set.dataset.kvR3Ids || '').split(',').filter(Boolean);
        var items = [line(cur, 1)];
        ids.forEach(function (id) { items.push(line(parseInt(id, 10), 1, '_kv_offer_addon')); });
        addToCart(items, btn);
        return;
      }
      return;
    }

    var choice = e.target.closest('[data-kv-r3-choice]');
    if (choice) {
      e.preventDefault();
      var wrap = choice.closest('.kv-r3-choice');
      $$('[data-kv-r3-choice]', wrap).forEach(function (c) {
        c.classList.toggle('is-active', c === choice);
      });
      var note = $('[data-kv-r3-choice-note]', wrap);
      if (note) note.hidden = choice.dataset.kvR3Choice !== 'set';
    }
  }

  /* The set choice rides along with the theme's own add to cart. Document
     capture beats product-form, whose listener is bound on the element in
     its constructor. */
  function onSubmit(e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('product-form.product-form form, form.product-form__form')) return;
    var active = $('.kv-r3-choice [data-kv-r3-choice="set"].is-active');
    if (!active) return;
    var addId = parseInt(active.dataset.kvR3Add, 10);
    var cur = currentVariantId();
    if (!addId || !cur) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart([line(cur, 1), line(addId, 1, '_kv_offer_addon')], f.querySelector('button[name="add"]'));
  }

  /* ---- boot ------------------------------------------------------------- */
  function apply() {
    host = $('[data-kv-r3]');
    if (!host) return;
    $$('[data-kv-r3-block]', host.parentNode ? document : host).forEach(function (block) {
      var id = block.dataset.kvTestEl;
      if (root.classList.contains('kv-' + String(id).toLowerCase())) place(block);
      else unplace(block);
    });
  }

  function syncModes() {
    var changed = false;
    IDS.forEach(function (id) {
      var cls = 'kv-' + id.toLowerCase();
      var marker = $('.kv-r3-mode[data-kv-test="' + id + '"]');
      if (isVisible(marker) && !root.classList.contains(cls)) {
        root.classList.add(cls);
        changed = true;
      }
    });
    if (changed) apply();
  }

  function boot() {
    host = $('[data-kv-r3]');
    if (!host) return;
    syncModes();
    apply();
  }

  document.addEventListener('click', onClick);
  document.addEventListener('submit', onSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);

  /* Intelligems can add the class straight onto html at any time. */
  if (window.MutationObserver) {
    new MutationObserver(function () { apply(); })
      .observe(root, { attributes: true, attributeFilter: ['class'] });
  }
  setTimeout(syncModes, 400);
  setTimeout(syncModes, 1500);
})();
